/* Generated by model-kit filter manifest generator — do not edit by hand. */
window.OVS_MK_FILTER_HANDLES = new Set([
    'model-kits',
    'entry-grade-eg',
    'high-grade-hg',
    'real-grade-rg',
    'perfect-grade-pg',
    'master-grade-mg',
    'mg-standard',
    'mg-ver-ka',
    'mgex',
    'master-grade-sd-mgsd',
    'sd-gundam',
    'sd-ex-standard',
    'sd-cross-silhouette',
    'sd-world-heroes',
    'sd-bb-senshi',
    'sd-g-generation',
    'sd-build-fighters',
    'sd-gunpla-kun',
    'gunpla-option-parts',
    'action-base',
    'hg-universal-century',
    'hg-gundam-seed',
    'hg-after-colony',
    'hg-iron-blooded-orphans',
    'hg-build-fighters',
    'hg-build-divers',
    'gundam-universal-century',
    'gundam-alternate-universes',
    'gundam-other-uc-series',
    'gundam-other-au-series',
    'gundam-mobile-suit-gundam',
    'gundam-zeta',
    'gundam-zz',
    'gundam-chars-counterattack',
    'gundam-0080',
    'gundam-f91',
    'gundam-0083',
    'gundam-08th-ms-team',
    'gundam-the-origin',
    'gundam-thunderbolt',
    'gundam-narrative',
    'gundam-sentinel',
    'gundam-unicorn',
    'gundam-seed',
    'gundam-wing',
    'gundam-00',
    'g-gundam',
    'gundam-build-fighters',
    'gundam-build-divers',
    'gundam-age',
    'gundam-hathaway',
    'gundam-iron-blooded-orphans',
    'gundam-witch-from-mercury',
    'gundam-reconguista-in-g',
    'gundam-x',
    'gundam-requiem-for-vengeance',
    'gundam-sd-franchise',
    'gundam-sd-world-heroes',
    'gundam-sangoku-soketsuden',
    'patlabor',
    'macross-delta',
    'armored-trooper-votoms',
    'mazinger',
    'getter-robo',
    'kotetsu-jeeg',
    'super-robot-wars',
    'armored-core',
    'doraemon',
    'sakura-wars',
    'linebarrels-of-iron',
    'other-series',
    '30-minutes-missions',
    '30-minutes-armored-core',
    '30-minutes-sisters',
    '30-minutes-fantasy',
    '30-minutes-preference',
    '30-minutes-accessories',
    'pokemon',
    'kotobukiya',
    'moderoid',
    'keroro',
    'snaa',
    'one-piece',
    'eureka-seven',
    'mechatrowego',
    'plamax',
    'evangelion',
    'figure-rise',
    'latest-arrivals'
]);
window.OVS_MK_FILTER_PROFILES = {
    'model-kits': 'gunpla-hub',
    'entry-grade-eg': 'grade-simple',
    'high-grade-hg': 'grade-simple',
    'real-grade-rg': 'grade-simple',
    'perfect-grade-pg': 'grade-simple',
    'master-grade-mg': 'grade-simple',
    'mg-standard': 'subline-shelf',
    'mg-ver-ka': 'subline-shelf',
    'mgex': 'subline-shelf',
    'master-grade-sd-mgsd': 'subline-shelf',
    'sd-gundam': 'grade-simple',
    'sd-ex-standard': 'subline-shelf',
    'sd-cross-silhouette': 'subline-shelf',
    'sd-world-heroes': 'subline-shelf',
    'sd-bb-senshi': 'subline-shelf',
    'sd-g-generation': 'subline-shelf',
    'sd-build-fighters': 'subline-shelf',
    'sd-gunpla-kun': 'subline-shelf',
    'gunpla-option-parts': 'accessories',
    'action-base': 'accessories',
    'hg-universal-century': 'subline-shelf',
    'hg-gundam-seed': 'subline-shelf',
    'hg-after-colony': 'subline-shelf',
    'hg-iron-blooded-orphans': 'subline-shelf',
    'hg-build-fighters': 'subline-shelf',
    'hg-build-divers': 'subline-shelf',
    'gundam-universal-century': 'uc-hub',
    'gundam-alternate-universes': 'au-hub',
    'gundam-other-uc-series': 'uc-other-hub',
    'gundam-other-au-series': 'au-other-hub',
    'gundam-mobile-suit-gundam': 'series-leaf',
    'gundam-zeta': 'series-leaf',
    'gundam-zz': 'series-leaf',
    'gundam-chars-counterattack': 'series-leaf',
    'gundam-0080': 'series-leaf',
    'gundam-f91': 'series-leaf',
    'gundam-0083': 'series-leaf',
    'gundam-08th-ms-team': 'series-leaf',
    'gundam-the-origin': 'series-leaf',
    'gundam-thunderbolt': 'series-leaf',
    'gundam-narrative': 'series-leaf',
    'gundam-sentinel': 'series-leaf',
    'gundam-unicorn': 'series-leaf',
    'gundam-seed': 'series-leaf',
    'gundam-wing': 'series-leaf',
    'gundam-00': 'series-leaf',
    'g-gundam': 'series-leaf',
    'gundam-build-fighters': 'series-leaf',
    'gundam-build-divers': 'series-leaf',
    'gundam-age': 'series-leaf',
    'gundam-hathaway': 'series-leaf',
    'gundam-iron-blooded-orphans': 'series-leaf',
    'gundam-witch-from-mercury': 'series-leaf',
    'gundam-reconguista-in-g': 'series-leaf',
    'gundam-x': 'series-leaf',
    'gundam-requiem-for-vengeance': 'series-leaf',
    'gundam-sd-franchise': 'series-leaf',
    'gundam-sd-world-heroes': 'series-leaf',
    'gundam-sangoku-soketsuden': 'series-leaf',
    'patlabor': 'franchise-leaf',
    'macross-delta': 'franchise-leaf',
    'armored-trooper-votoms': 'franchise-leaf',
    'mazinger': 'franchise-leaf',
    'getter-robo': 'franchise-leaf',
    'kotetsu-jeeg': 'franchise-leaf',
    'super-robot-wars': 'franchise-leaf',
    'armored-core': 'franchise-leaf',
    'doraemon': 'franchise-leaf',
    'sakura-wars': 'franchise-leaf',
    'linebarrels-of-iron': 'franchise-leaf',
    'other-series': 'franchise-rollup',
    '30-minutes-missions': '30mm-hub',
    '30-minutes-armored-core': '30mm-leaf',
    '30-minutes-sisters': '30mm-leaf',
    '30-minutes-fantasy': '30mm-leaf',
    '30-minutes-preference': '30mm-leaf',
    '30-minutes-accessories': '30mm-leaf',
    'pokemon': 'brand-leaf',
    'kotobukiya': 'brand-leaf',
    'moderoid': 'brand-leaf',
    'keroro': 'brand-leaf',
    'snaa': 'brand-leaf',
    'one-piece': 'brand-leaf',
    'eureka-seven': 'brand-leaf',
    'mechatrowego': 'brand-leaf',
    'plamax': 'brand-leaf',
    'evangelion': 'brand-leaf',
    'figure-rise': 'brand-leaf',
    'latest-arrivals': 'gunpla-hub'
};
window.OVS_MK_SHELF_DEFAULTS = {"entry-grade-eg":{"grades":["eg"]},"high-grade-hg":{"grades":["hg"]},"real-grade-rg":{"grades":["rg"]},"perfect-grade-pg":{"grades":["pg"]},"master-grade-mg":{"grades":["mg"]},"mg-standard":{"grades":["mg-standard"]},"mg-ver-ka":{"grades":["ver_ka"]},"mgex":{"grades":["mgex"]},"master-grade-sd-mgsd":{"grades":["mgsd"]},"sd-gundam":{"grades":["sd"]},"sd-ex-standard":{"grades":["ex_standard"]},"sd-cross-silhouette":{"grades":["cross_silhouette"]},"sd-world-heroes":{"grades":["sdw"]},"sd-bb-senshi":{"grades":["bb_senshi"]},"sd-g-generation":{"grades":["g_generation"]},"sd-build-fighters":{"grades":["sdbf"]},"sd-gunpla-kun":{"grades":["gunpla_kun"]},"hg-universal-century":{"grades":["hguc"]},"hg-gundam-seed":{"grades":["hgce"]},"hg-after-colony":{"grades":["hgac"]},"hg-iron-blooded-orphans":{"grades":["hgibo"]},"hg-build-fighters":{"grades":["hgbf"]},"hg-build-divers":{"grades":["hgbd"]},"30-minutes-missions":{"lines":["30mm"]},"30-minutes-armored-core":{"lines":["30mm_armored_core"]},"30-minutes-sisters":{"lines":["30ms"]},"30-minutes-fantasy":{"lines":["30mf"]},"30-minutes-preference":{"lines":["30mp"]},"30-minutes-accessories":{"lines":["30mm_accessories"]}};
window.OVS_MK_GRADE_COLLECTIONS = {"eg":"entry-grade-eg","rg":"real-grade-rg","pg":"perfect-grade-pg","re_100":"re-100","fm":"full-mechanics","mega_size":"mega-size","hg":"high-grade-hg","sd":"sd-gundam","mg":"master-grade-mg","hguc":"hg-universal-century","hgce":"hg-gundam-seed","hgac":"hg-after-colony","hgibo":"hg-iron-blooded-orphans","hgbf":"hg-build-fighters","hgbd":"hg-build-divers","mg-standard":"mg-standard","ver_ka":"mg-ver-ka","mgex":"mgex","mgsd":"master-grade-sd-mgsd","ex_standard":"sd-ex-standard","cross_silhouette":"sd-cross-silhouette","sdw":"sd-world-heroes","bb_senshi":"sd-bb-senshi","g_generation":"sd-g-generation","sdbf":"sd-build-fighters","gunpla_kun":"sd-gunpla-kun","option-parts":"gunpla-option-parts","action-base":"action-base"};
window.OVS_MK_LINE_COLLECTIONS = {"30mm":"30-minutes-missions","30mm_armored_core":"30-minutes-armored-core","30ms":"30-minutes-sisters","30mf":"30-minutes-fantasy","30mp":"30-minutes-preference","30mm_accessories":"30-minutes-accessories"};
window.OVS_MK_GUNPLA_POOL_HANDLES = new Set(["model-kits","latest-arrivals"]);
window.OVS_MK_GUNPLA_HUB_HANDLE = 'model-kits';
window.OVS_MK_HUB_PREFILTERS = {"entry-grade-eg":{"grades":["eg"]},"high-grade-hg":{"grades":["hg"]},"real-grade-rg":{"grades":["rg"]},"perfect-grade-pg":{"grades":["pg"]},"master-grade-mg":{"grades":["mg"]},"mg-standard":{"grades":["mg-standard"]},"mg-ver-ka":{"grades":["ver_ka"]},"mgex":{"grades":["mgex"]},"master-grade-sd-mgsd":{"grades":["mgsd"]},"sd-gundam":{"grades":["sd"]},"sd-ex-standard":{"grades":["ex_standard"]},"sd-cross-silhouette":{"grades":["cross_silhouette"]},"sd-world-heroes":{"grades":["sdw"]},"sd-bb-senshi":{"grades":["bb_senshi"]},"sd-g-generation":{"grades":["g_generation"]},"sd-build-fighters":{"grades":["sdbf"]},"sd-gunpla-kun":{"grades":["gunpla_kun"]},"gunpla-option-parts":{"grades":["option-parts"]},"action-base":{"grades":["action-base"]},"hg-universal-century":{"grades":["hguc"]},"hg-gundam-seed":{"grades":["hgce"]},"hg-after-colony":{"grades":["hgac"]},"hg-iron-blooded-orphans":{"grades":["hgibo"]},"hg-build-fighters":{"grades":["hgbf"]},"hg-build-divers":{"grades":["hgbd"]},"gundam-universal-century":{"series":["uc-all"]},"gundam-alternate-universes":{"series":["au-all"]},"gundam-other-uc-series":{"series":["gundam_f91","the_08th_ms_team","gundam__the_origin","gundam_thunderbolt","gundam_narrative","gundam_sentinel","gundam_reconguista_in_g","gundam__requiem_for_vengeance","nextuc","advance_of_zeta","titanomachia","mobile_suit_crossbone_gundam"]},"gundam-other-au-series":{"series":["gundam_x"]},"gundam-mobile-suit-gundam":{"series":["mobile_suit_gundam"]},"gundam-zeta":{"series":["zeta_gundam"]},"gundam-zz":{"series":["gundam_zz"]},"gundam-chars-counterattack":{"series":["char_s_counterattack"]},"gundam-0080":{"series":["gundam_0080__war_in_the_pocket"]},"gundam-f91":{"series":["gundam_f91"]},"gundam-0083":{"series":["gundam_0083__stardust_memory"]},"gundam-08th-ms-team":{"series":["the_08th_ms_team"]},"gundam-the-origin":{"series":["gundam__the_origin"]},"gundam-thunderbolt":{"series":["gundam_thunderbolt"]},"gundam-narrative":{"series":["gundam_narrative"]},"gundam-sentinel":{"series":["gundam_sentinel"]},"gundam-unicorn":{"series":["gundam_unicorn"]},"gundam-seed":{"series":["gundam_seed","gundam_seed_destiny","gundam_seed_freedom","gundam_seed_astray","gundam_seed_stargazer"]},"gundam-wing":{"series":["gundam_wing","gundam_wing__endless_waltz"]},"gundam-00":{"series":["gundam_00"]},"g-gundam":{"series":["g_gundam"]},"gundam-build-fighters":{"series":["gundam_build_fighters"]},"gundam-build-divers":{"series":["gundam_build_divers","gundam_build_divers_re_rise","gundam_build_metaverse","buildmetaverse","gundam_breaker_battlogue"]},"gundam-age":{"series":["gundam_age"]},"gundam-hathaway":{"series":["gundam_hathaway","hathaway"]},"gundam-iron-blooded-orphans":{"series":["iron_blooded_orphans"]},"gundam-witch-from-mercury":{"series":["the_witch_from_mercury","mobile_suit_gundam_gquuuuuux"]},"gundam-reconguista-in-g":{"series":["gundam_reconguista_in_g"]},"gundam-x":{"series":["gundam_x"]},"gundam-requiem-for-vengeance":{"series":["gundam__requiem_for_vengeance"]},"gundam-sd-franchise":{"grades":["sd"],"series":["sd_gundam","sd_gundam_world_heroes","gundam_world_sangoku_soketsuden"]},"gundam-sd-world-heroes":{"grades":["sd"],"series":["sd_gundam_world_heroes"]},"gundam-sangoku-soketsuden":{"grades":["sd"],"series":["gundam_world_sangoku_soketsuden"]},"patlabor":{"franchises":["patlabor"]},"macross-delta":{"franchises":["macross_delta"]},"armored-trooper-votoms":{"franchises":["armored_trooper_votoms"]},"mazinger":{"franchises":["mazinger"]},"getter-robo":{"franchises":["getter_robo"]},"kotetsu-jeeg":{"franchises":["kotetsu_jeeg"]},"super-robot-wars":{"franchises":["super_robot_wars"]},"armored-core":{"franchises":["armored_core"]},"doraemon":{"franchises":["doraemon"]},"sakura-wars":{"franchises":["sakura_wars"]},"linebarrels-of-iron":{"franchises":["linebarrels_of_iron"]},"other-series":{"franchises":["doraemon","mazinger","getter_robo","kotetsu_jeeg","patlabor","macross_delta","armored_trooper_votoms","sakura_wars","linebarrels_of_iron","eureka_seven","one_piece"],"lines":["eureka_seven"]},"30-minutes-missions":{"lines":["30mm"]},"30-minutes-armored-core":{"lines":["30mm_armored_core"]},"30-minutes-sisters":{"lines":["30ms"]},"30-minutes-fantasy":{"lines":["30mf"]},"30-minutes-preference":{"lines":["30mp"]},"30-minutes-accessories":{"lines":["30mm_accessories"]},"pokemon":{"franchises":["pokemon"]},"kotobukiya":{"franchises":["kotobukiya"]},"moderoid":{"franchises":["moderoid"]},"keroro":{"franchises":["keroro"]},"snaa":{"franchises":["snaa"]},"one-piece":{"franchises":["one_piece"]},"eureka-seven":{"lines":["eureka_seven"]},"mechatrowego":{"franchises":["mechatrowego"]},"plamax":{"franchises":["plamax"]},"evangelion":{"franchises":["evangelion"]},"figure-rise":{"franchises":["figure_rise"]},"re-100":{"grades":["re_100"]},"full-mechanics":{"grades":["fm"]},"mega-size":{"grades":["mega_size"]}};
window.OVS_MK_SHELF_TITLES = {"model-kits":"Model kits","entry-grade-eg":"Entry Grade","high-grade-hg":"High Grade (HG)","real-grade-rg":"Real Grade (RG)","perfect-grade-pg":"Perfect Grade (PG)","master-grade-mg":"Master Grade (MG)","mg-standard":"MG","mg-ver-ka":"MG Ver.Ka","mgex":"MGEX","master-grade-sd-mgsd":"Master Grade SD (MGSD)","sd-gundam":"SD Gundam","sd-ex-standard":"SD EX-Standard","sd-cross-silhouette":"SD Cross Silhouette","sd-world-heroes":"SD World Heroes","sd-bb-senshi":"SD BB Senshi","sd-g-generation":"SD G Generation","sd-build-fighters":"SD Build Fighters","sd-gunpla-kun":"Gunpla-kun","gunpla-option-parts":"Gunpla Option Parts","action-base":"Action Bases","hg-universal-century":"HG Universal Century","hg-gundam-seed":"HG Gundam SEED","hg-after-colony":"HG After Colony","hg-iron-blooded-orphans":"HG Iron-Blooded Orphans","hg-build-fighters":"HG Build Fighters","hg-build-divers":"HG Build Divers","gundam-universal-century":"Gundam Universal Century","gundam-alternate-universes":"Gundam Alternate Universes","gundam-other-uc-series":"Other UC series","gundam-other-au-series":"Other AU series","gundam-mobile-suit-gundam":"Mobile Suit Gundam","gundam-zeta":"Zeta Gundam","gundam-zz":"Gundam ZZ","gundam-chars-counterattack":"Char's Counterattack","gundam-0080":"Gundam 0080: War in the Pocket","gundam-f91":"Gundam F91","gundam-0083":"Gundam 0083: Stardust Memory","gundam-08th-ms-team":"The 08th MS Team","gundam-the-origin":"Gundam: The Origin","gundam-thunderbolt":"Gundam Thunderbolt","gundam-narrative":"Gundam Narrative","gundam-sentinel":"Gundam Sentinel","gundam-unicorn":"Gundam Unicorn","gundam-seed":"Gundam SEED","gundam-wing":"Gundam Wing","gundam-00":"Gundam 00","g-gundam":"G Gundam","gundam-build-fighters":"Gundam Build Fighters","gundam-build-divers":"Gundam Build Divers","gundam-age":"Gundam Age","gundam-hathaway":"Gundam Hathaway's Flash","gundam-iron-blooded-orphans":"Gundam Iron-Blooded Orphans","gundam-witch-from-mercury":"Gundam The Witch from Mercury","gundam-reconguista-in-g":"Gundam Reconguista in G","gundam-x":"After War Gundam X","gundam-requiem-for-vengeance":"Gundam: Requiem for Vengeance","gundam-sd-franchise":"SD Gundam","gundam-sd-world-heroes":"SD Gundam World Heroes","gundam-sangoku-soketsuden":"Gundam World Sangoku Soketsuden","patlabor":"Patlabor","macross-delta":"Macross Delta","armored-trooper-votoms":"Armored Trooper Votoms","mazinger":"Mazinger","getter-robo":"Getter Robo","kotetsu-jeeg":"Kotetsu Jeeg","super-robot-wars":"Super Robot Wars","armored-core":"Armored Core","doraemon":"Doraemon","sakura-wars":"Sakura Wars","linebarrels-of-iron":"Linebarrels of Iron","other-series":"Other series","30-minutes-missions":"30 Minutes Missions","30-minutes-armored-core":"30 Minutes Missions Armored Core","30-minutes-sisters":"30 Minutes Sisters","30-minutes-fantasy":"30 Minutes Fantasy","30-minutes-preference":"30 Minutes Preference","30-minutes-accessories":"30 Minutes Accessories","pokemon":"Pok\u00e9mon","kotobukiya":"Kotobukiya","moderoid":"MODEROID","keroro":"Keroro","snaa":"SNAA","one-piece":"One Piece","eureka-seven":"Eureka Seven","mechatrowego":"MechatroWeGo","plamax":"PLAMAX","evangelion":"Evangelion","figure-rise":"Figure-rise","re-100":"RE/100","full-mechanics":"Full Mechanics","mega-size":"Mega Size"};

(function () {
  if (!window.OVS_MK_HUB_ONLY) {
    return;
  }

  const hub = window.OVS_MK_GUNPLA_HUB_HANDLE || 'model-kits';
  const parts = window.location.pathname.split('/').filter(Boolean);
  const handle = parts[parts.length - 1] || '';
  if (handle === hub || handle === 'latest-arrivals' || handle === 'beginner-kits') {
    return;
  }

  const params = new URLSearchParams(window.location.search);

  if (handle === 'gunpla') {
    const legacyUrl = new URL('/collections/' + hub, window.location.origin);
    params.forEach((value, key) => {
      legacyUrl.searchParams.set(key, value);
    });
    window.location.replace(legacyUrl.pathname + legacyUrl.search);
    return;
  }

  const pref = window.OVS_MK_HUB_PREFILTERS?.[handle];
  if (!pref || typeof pref !== 'object') {
    return;
  }

  if (
    params.has('ovs_mk_grade') ||
    params.has('ovs_mk_series') ||
    params.has('ovs_mk_franchise') ||
    params.has('ovs_mk_line') ||
    params.has('ovs_mk_price') ||
    params.has('ovs_mk_latest_arrival')
  ) {
    return;
  }

  const url = new URL('/collections/' + hub, window.location.origin);
  const preview = params.get('preview_theme_id');
  if (preview) {
    url.searchParams.set('preview_theme_id', preview);
  }
  if (Array.isArray(pref.grades) && pref.grades.length > 0) {
    url.searchParams.set('ovs_mk_grade', pref.grades.join(','));
  }
  if (Array.isArray(pref.series) && pref.series.length > 0) {
    url.searchParams.set('ovs_mk_series', pref.series.join(','));
  }
  if (Array.isArray(pref.franchises) && pref.franchises.length > 0) {
    url.searchParams.set('ovs_mk_franchise', pref.franchises.join(','));
  }
  if (Array.isArray(pref.lines) && pref.lines.length > 0) {
    url.searchParams.set('ovs_mk_line', pref.lines.join(','));
  }

  window.location.replace(url.pathname + url.search);
})();
